import React from "react"
import YaseenData from "./Data/Yaseen/Data.json"
import Appbar from "../Component/Appbar"
import { Paper, Typography, Avatar, Fab, AppBar, Toolbar, Container, Button, FormControl, Grow, Grid } from "@material-ui/core"
import withStyles from '@material-ui/core/styles/withStyles';
import { Translate, I18n } from "react-redux-i18n";
import Config from "../Constants/Constants";
import { bindActionCreators } from "redux"
import { connect } from 'react-redux'
import { Fade } from 'react-reveal';
import BottomBar from "../Component/BottomBar"
import ShareIcon from '@material-ui/icons/Share';
import { Helmet } from "react-helmet";
import MenuBar from "../Component/Menubar";

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flow-root',
        flexDirection: 'column',
        marginTop: "4px",
        fontFamily: "Scheherazade, Scheheraza!important",
        // alignItems: 'center',
        padding: `10px 10px 10px`,
        // background:"antiquewhite",
        background: "white",
        "&:hover": {
            background: "whitesmoke",
            color: "black"
        }
    },
    number: {
        fontSize: "15px",
        float: "left",
        // position:"absolute",
        background: "linear-gradient(-135deg,#4fbdf0,#3899de)",
        color: 'white',
        width: "33px",
        height: "30px",
        // marginTop:"12px"
    },
    audio: {
        width: "100%",
        background: "whitesmoke"
    },
    name: {
        marginLeft: "69px",
        marginTop: "17px"
    },

    meaning: {
        marginTop: "20px",
        textAlign: "start",
        fontFamily: "Scheherazade, Scheheraza!important"

    },
    bottomBar: {
        bottom: 0,
        background: "whitesmoke",
        top: 'auto'

    },
    arabic: {
        float: "right",
        // marginLeft:"69px",
        marginTop: "17px",
        fontSize: "30px",
        // fontWeight:"bold",
        fontFamily: "Scheherazade, Scheheraza!important"
    },
    explanation: {
        marginTop: "20px",
        // fontFamily:"ariral, sans-serif"
        // paddingTop:"20px"
        background: "white"
    },
    meaning: {
        color: "seagreen",
        marginTop: "35px",
        textAlign: "left"
    },
    translation: {
        background: "white"
    },
    english: {
        marginTop: "41px",
        color: "black",
        fontSize: "15px",
        textAlign: "left",
        // fontFamily:"Scheherazade, Scheheraza!important"
        // fontFamily:"ariral, sans-serif"
    },
    reference: {
        fontSize: "14px",
        color: "slategrey"
    },
    shareIcon: {
        textAlign: "right",
        color: "slategrey",
        fontSize: "40px",
        float: "right"
    }


});
class ViewHadith extends React.Component {
    constructor(props) {
        super(props)
        const { params: { language, hadithtitle } } = props.match
        I18n.setLocale(language);

        this.state = {
            loading: false,
            audioEnabled: true,
            open: false,
            language: language==="null"?"English":language,
            selectedHadith: hadithtitle,
            viewHadith: this.props.user.hadith.filter(hadith => hadith[`${language}Category`] === hadithtitle)
        }
        console.log(this.props.user.hadith.filter(hadith => hadith[`${language}Category`] === hadithtitle));
    }
    componentDidMount() {
        document.title = `Islamic Hadith | Hadith | Alif Islamic Learning App`

    }

    selectLanguage() {
        var language = localStorage.getItem("language")
        this.setState({
            loading: !this.state.loading,
            language: language==="null"?"English":language,
            urlAudio: `${Config.urldata}${YaseenData.lang[language].audio}`
        })
        document.getElementById("yaseenAudio").src = `${Config.urldata}${YaseenData.lang[language].audio}`
    }



    handleClose = () => {
        this.setState({ open: false })
    }
    hadithTitle = (value) => {
        console.log(value);
        this.props.user.selectedHadith = value
        // window.location.href = "#/viewquran"
    }
    shareData = (value) => {
        console.log(value);
        this.props.user.shareFeatureData = value
        localStorage.setItem("sharefeature", window.location.hash)
        window.location.href = "#/shareimage"
    }
    render() {
        const { classes } = this.props
        let { selectedHadith, language } = this.state
        if(language===undefined||language===""||language===null){
            language="English"
            I18n.setLocale(language);
        }
        // const folder=window.cordova.file.externalRootDirectory + 'Download/'
        return (
            <div>
            <MenuBar language={language}/>
                <Helmet>
                    <meta name="description"
                        content="Islamic Hadith in English, Tamil, Urdu Languages .Learn one hadith a day and share to your family and friends. Allah may rewards you" />
                    <title>{selectedHadith} hadith in  {language} </title>
                </Helmet>
                <Container>
                    <Grid container >
                        <Grid item xs={12}>
                            <Paper>
                                <Typography component="h6" variant="h6">
                                    <Translate value="home.hadith" /> {selectedHadith}
                                </Typography>
                            </Paper>
                            <Grow in>
                                <ViewSurahTitle css={classes} language={language} shareData={this.shareData} selectedHadith={selectedHadith} hadith={this.state.viewHadith} />
                            </Grow>
                        </Grid>
                    </Grid>
                    <div style={{ 'margin-top': "100px" }}></div>
                </Container>
            </div>
        )
    }
}

function ViewSurahTitle(props) {
    var list = []
    console.log(props);
    var language = localStorage.getItem("language")
    for (var index in props.hadith) {
        list.push(
            <Grow in>
                <Paper className={props.css.paper} >
                    <span className={props.css.shareIcon}>
                        <ShareIcon className={props.css.shareIcon} onClick={props.shareData.bind(null, {
                            children: {
                                ...props.selectedHadith
                            },
                            title: props.selectedHadith,
                            Language: props.hadith[index][`${props.language}Description`],
                            reference: props.hadith[index]["Reference"],
                            type: "HADITH"
                        })} />
                    </span>
                    <Fab className={props.css.number}>
                        {parseInt(index) + 1}
                    </Fab>
                    <Typography>
                        <Typography className={props.css.english}>
                            {props.hadith[index][`${props.language}Description`]}
                        </Typography>
                        <Typography className={props.css.reference}>
                            {props.hadith[index]['Reference']}
                        </Typography>
                    </Typography>

                </Paper>
            </Grow>

        )
    }
    return list
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
        }, dispatch
    )
}

var hadithOverView = connect(mapStateToProps, matchDispatchToProps)(ViewHadith);
var connectFile = withStyles(styles)(hadithOverView)
export default connectFile


// export default withStyles(styles)(Names)import { bindActionCreators } from "redux"